export const DISPLAY_STEP = 5;

// Purchase states
export const STATE_PENDING = 1;
export const STATE_VALID = 2;
export const STATE_INVALID = 4;

// Estimated number of days to validate a payment request
export const PAYMENT_DELAY = 21;

// Parity for tree conversion
export const TREE_PARITY_EURO_TTC = 2.86;

// Payment request states
export const PAYMENT_REQUEST_STATE_UNPROCESSED = 0;
export const PAYMENT_REQUEST_STATES_PENDING = [0, 1, 2];
export const PAYMENT_REQUEST_STATES_VALID = [3];
export const PAYMENT_REQUEST_STATES_INVALID = [4, 5];



// WEBPACK FOOTER //
// ./src/constants/payment.js